
export class RouteGroup {

    id: number;
    calendar_group: number;
    dispatch_group_id: number;
    title: string;
    acct: string;
    created: string;

    constructor(id: number, title: string, acct: string, calendar_group: number, dispatch_group_id: number, created: string) {
        this.id = id;
        this.calendar_group = calendar_group;
        this.dispatch_group_id = dispatch_group_id;
        this.title = title;
        this.acct = acct;
        this.created = created;
    }
}

export class RouteGroupCreate {

    id: number;
    calendar_group: number;
    dispatch_group_id: number;
    title: string;
    acct: string;
    created: string;

    constructor(title: string, acct: string, calendar_group: number, dispatch_group_id: number) {
        this.calendar_group = calendar_group;
        this.dispatch_group_id = dispatch_group_id;
        this.title = title;
        this.acct = acct;
    }
}

